<template>
  <div id="app">
    <template v-if="!error">
      <div class="wrap-content">
        <div class="wrap-header">
          <LangSwitcher /> 
          <Login v-if="insert_dev_component == 'true'" />
        </div>
        <Receipt />
      </div>
    </template>
    <template v-else> 
      <ErrorPage />
    </template>
  </div>
</template>

<script>
import Login from './components/Login.vue'
import Receipt from './components/Receipt.vue'
import ErrorPage from './components/ErrorPage.vue'
import LangSwitcher from './components/LangSwitcher.vue'

export default {
  name: 'App',
  components: {
    LangSwitcher,
    ErrorPage,
    Receipt,
    Login
  },
  data() {
    return {
      error: false,
      insert_dev_component: null
    }
  },
  beforeMount() {
    this.insert_dev_component = process.env.VUE_APP_INSERT_DEV_COMPONENTS; 

    let url_string = window.location.href;
    let url = new URL(url_string);

    try{
      let params = "";

      let tenant = url.searchParams.get("tenant"); 
      if(tenant != '' && tenant != 'null' && tenant != null){ 
        localStorage.setItem("receipt_tenant", tenant);
      }else{
        this.error = true;
      }

      let customer_id_type = url.searchParams.get("customer_id_type"); 
      if(customer_id_type != '' && customer_id_type != 'null' && customer_id_type != null){ 
        params = this.buildString(params, "customer_id_type="+customer_id_type);
      }

      let customer_id = url.searchParams.get("customer_id"); 
      if(customer_id != '' && customer_id != 'null' && customer_id != null){ 
        params = this.buildString(params, "customer_id="+customer_id);
      }

      let serial_number = url.searchParams.get("serial_number"); 
      if(serial_number != '' && serial_number != 'null' && serial_number != null){ 
        params = this.buildString(params, "serial_number="+serial_number);
      }

      let pos_id = url.searchParams.get("pos_id"); 
      if(pos_id != '' && pos_id != 'null' && pos_id != null){ 
        params = this.buildString(params, "pos_id="+pos_id);
      }

      let store_id = url.searchParams.get("store_id"); 
      if(store_id != '' && store_id != 'null' && store_id != null){ 
        params = this.buildString(params, "store_id="+store_id);
      }

      let till_number = url.searchParams.get("till_number"); 
      if(till_number != '' && till_number != 'null' && till_number != null){ 
        params = this.buildString(params, "till_number="+till_number);
      }

      let z_rep_number = url.searchParams.get("z_rep_number"); 
      if(z_rep_number != '' && z_rep_number != 'null' && z_rep_number != null){         
        params = this.buildString(params, "z_rep_number="+z_rep_number);
      }

      let date_time = url.searchParams.get("date_time"); 
      if(date_time != '' && date_time != 'null' && date_time != null){ 
        params = this.buildString(params, "date_time="+date_time);
      }

      let rec_number = url.searchParams.get("rec_number"); 
      if(rec_number != '' && rec_number != 'null' && rec_number != null){ 
        params = this.buildString(params, "rec_number="+rec_number);
      }

      let transaction_id = url.searchParams.get("transaction_id"); 
      if(transaction_id != '' && transaction_id != 'null' && transaction_id != null){ 
        params = this.buildString(params, "transaction_id="+transaction_id);
      }

      let vat_number = url.searchParams.get("vat_number"); 
      if(vat_number != '' && vat_number != 'null' && vat_number != null){ 
        params = this.buildString(params, "vat_number="+vat_number);
      }

      let rec_amount = url.searchParams.get("rec_amount"); 
      if(rec_amount != '' && rec_amount != 'null' && rec_amount != null){ 
        params = this.buildString(params, "rec_amount="+rec_amount);
      }

      let rec_encrypted = url.searchParams.get("r"); 
      if(rec_encrypted != '' && rec_encrypted != 'null' && rec_encrypted != null){ 
        params = this.buildString(params, "r="+encodeURIComponent(rec_encrypted));
      }

      if(params.length === 0){ 
        this.error = true;
      }else{
        localStorage.setItem("receipt_params", params);
      }

    }catch(Exception){ 
      console.log(Exception);
      this.error = true;
    }
  },
  methods: {
    buildString(str, new_val) {
      if(str == "") {
        str = new_val;
      }else{
        str += "&"+new_val;
      }

      return str;
    }
  }
}
</script>

<style>
  html * {
    font-family: 'Sofia Pro', sans-serif;
    -webkit-tap-highlight-color: transparent;    
    -webkit-user-select: none;
    /*-khtml-user-select: none;*/
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  body {
    margin: 0px;
    display: flex;
    justify-content: center;
    background: #343434;
  }
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: white;
    text-align: center;
    max-width: 800px;
    height: 100vh;
    width: 100%;
  }
  div.wrap-content {
    padding: 20px 40px;
    width: 100%;
    height: 100%;
    background-color: #e9ecef;
  }
  div.wrap-header {
    width: 100%;
    display: flex;
    cursor: pointer;
    font-size: 13px;
    margin-bottom: 10px;
    text-transform: uppercase;
    justify-content: flex-end;
  }
  a.link {
    text-decoration: none !important;
  }
  iframe {
    display: none;
  }

  @media screen and (max-width: 600px) {
    div.wrap-content {
      padding: 20px;
    }
  }
</style>
